/**
 * Tags are an extensible data structure used for keeping track of additional data (e.g., services, fuel availability)
 * for airports and businesses.
 */
export class Tag {
  /**
   * Unique identifier for this record in the database. Note that this property only identifies the tag definition
   * record itself, and not the specific record that links this tag to a business or an airport (see AirportTag.aptTagId
   * and BusinessTag.businessTagId).
   */
  tagId: number;

  /**
   * Tag name, which consists of a series of double-colon-delimited strings (for example,
   * "Transportation::Rental Car::Hertz", or "Rental::Airplane::Single Engine"). Tag names have a hierarchical structure
   * which groups them by category, sub-category, etc., and only the last piece is typically ever presented to the user
   * for display.
   */
  tagName: string;

  /**
   * Description of tag.
   *
   */
  description: string;

  /**
   * Active status of tag.
   */
  isActive: boolean;

  /**
   * Returns the display name of the tag (last portion of the name), or null if this tag is not meant for user display
   * (e.g., "Fuel::Providers::", which is only used for grouping).
   */
  get displayName(): string {
    return (this.tagName || '').split('::').slice(-1)[0] || null;
  }

  /**
   * Parses tag
   * @param data {any} Tag as returned by API
   * @return {Tag} Parsed tag
   */
  static parse(data: any): Tag {
    return Object.assign(new Tag(), {
      tagId: data.tagId,
      tagName: data.tagName,
      isActive: data.isActive
    });
  }
}
